<template>
  <el-button
    v-bind="bindProps"
    :type="buttonType"
    :style="buttonVars"
    :class="[`el-button--${type}`, { 'basic-btn': colorVar }]"
    v-on="$listeners"
  >
    <template v-for="(_, key) in $slots" v-slot:[key]>
      <slot :name="key" />
    </template>
  </el-button>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'default'
    },
    // 自定义按钮颜色
    color: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      buttonTypes: ['primary', 'success', 'warning', 'danger', 'info', 'text']
    }
  },
  computed: {
    bindProps () {
      return { ...this.$attrs, type: this.type, color: this.color }
    },
    buttonType () {
      const type = this.type
      return this.buttonTypes.includes(type) ? type : 'default'
    },
    colorVar () {
      return this.color
    },
    buttonVars () {
      const color = this.color ? this.color : '#fff'
      const opcity1 = this.hexToRgba(color, 0.1)
      const opcity3 = this.hexToRgba(color, 0.3)
      return {
        '--color': color,
        '--opcity1': opcity1,
        '--opcity3': opcity3
      }
    }
  },
  methods: {
    /** 十六进制颜色值生成rgba颜色值 */
    hexToRgba (hex, alpha) {
      // 去除十六进制颜色值中的#符号
      hex = hex.replace('#', '')

      // 解析十六进制颜色值的R、G、B部分
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)

      // 返回RGBA格式的颜色值
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin button-plain($color) {
  color: $color;
  background-color: var(--opcity1);
  border-color: var(--opcity3);

  &:hover,
  &:focus {
    background-color: $color;
    border-color: $color;
    color: #fff;
  }

  &:active {
    background-color: $color;
    border-color: $color;
    outline: none;
    color: #fff;
  }

  &.is-disabled {
    &,
    &:hover,
    &:focus,
    &:active {
      background-color: var(--opcity1);
      border-color: var(--opcity3);
      color: $color;
      opacity: 0.5;
    }
  }
}

@mixin button-variant($color) {
  background-color: $color;
  border-color: $color;
  color: #fff;

  &:hover,
  &:focus {
    background-color: $color;
    border-color: $color;
  }

  &:active {
    background-color: $color;
    border-color: $color;
  }

  &.is-active {
    background-color: $color;
    border-color: $color;
  }

  &.is-disabled {
    &,
    &:hover,
    &:focus,
    &:active {
      background-color: $color;
      border-color: $color;
      opacity: 0.5;
      color: #fff;
    }
  }

  &.is-plain {
    @include button-plain($color);
  }
  &.el-button--text {
    border-color: transparent;
    color: $color;
    background: transparent;
    padding-left: 0;
    padding-right: 0;
  }
}

.basic-btn {
  @include button-variant(var(--color));
}
</style>



// WEBPACK FOOTER //
// src/components/basic/basic-button.vue